import { EventPageVisibility, GetVisibilityConfigQuery } from '@graphql/generated';
import { VisibilityConfig } from '@shared/components/PageSettingsDialog/PageSettingsDialog.types';

export const formatVisibilityConfig = (data?: GetVisibilityConfigQuery): VisibilityConfig | undefined => {
  if (!data) {
    return;
  }
  const { event, eventPage } = data;

  let visibility;
  if (eventPage?.private) {
    visibility = EventPageVisibility.passwordProtected;
  } else {
    visibility = eventPage?.disabled ? EventPageVisibility.hidden : EventPageVisibility.public;
  }

  const password = event?.info?.eventPassword || '';

  return { visibility, password };
};

export const getVisibilityTranslation = (visibilityTranslations: Record<string, () => string>, visibility?: EventPageVisibility): string => {
  if (!visibility) return '';
  switch (visibility) {
    case EventPageVisibility.public:
      return visibilityTranslations.public();
    case EventPageVisibility.hidden:
      return visibilityTranslations.hidden();
    case EventPageVisibility.passwordProtected:
      return visibilityTranslations.passwordProtected();
    default:
      return '';
  }
};
